import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { EnvironmentConfig } from '../../../environments/environmentConfig';

declare var $: any;
@Component({
  selector: 'income',
  templateUrl: './income.component.html',
  styleUrls: ['./income.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class IncomeComponent implements OnInit {
  currentLang: string;
  $: any;
  incomeObj: any = {};
  isSelected: boolean = false;
  enumData: any;
  currentRoutePath: string;
  applicantName: any;
  preQualObj: any;
  tooltipClicked: boolean = true;
  disableProceed: boolean;
  colorForTb: boolean = true;
  loader: boolean = false;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  isIos: boolean;
  txtboxDisable: boolean;
  isValid: boolean;
  innerWidth: number;
  flowType: any;
  prequalType = 'P';
  switchType = 'S';
  currLangEn = 'en';
  currLangFr = 'fr';

  isIosDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  constructor(private util: UtilService, private _activatedRoute: ActivatedRoute,
    private formUtiObj: FrameworkUtilityComponent, private router: Router) {
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    /**
     * Check if this screen is for primary or co-applicant and set the progress percentage
     */
    this.preQualObj = this.util.getSessionStorage();

    this.enumData = this.util.getEnumData();
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
  }
  ngOnInit(): void {
    this.util.windowWidth.subscribe(val => {
      this.innerWidth = val;
    });
    document.onkeydown = function (evt: any) {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
        isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {

        if ($("#clsTooltipa")) {
        }

      }
    };
    this.colorForTb = true;
    this.preQualObj = this.util.getSessionStorage();
    this.currentLang = sessionStorage.getItem("currLang")

    if (this.preQualObj.users.length == 2) {
      if (this.currentLang == this.currLangEn) {
        this.applicantName = this.preQualObj.users[this.preQualObj.users.length - 2].firstname + "'s and " + this.preQualObj.users[this.preQualObj.users.length - 1].firstname + "'s" + " ";

      }
      else {

        this.applicantName = this.preQualObj.users[this.preQualObj.users.length - 2].firstname + " et de  " + this.preQualObj.users[this.preQualObj.users.length - 1].firstname;

      }
    } else {
      if (this.currentLang == this.currLangEn) {
        this.applicantName = this.preQualObj.users[this.preQualObj.users.length - 1].firstname + "'s" + " ";
      } else {
        this.applicantName = this.preQualObj.users[this.preQualObj.users.length - 1].firstname + " ";

      }
    }
    this.formUtiObj.InitValues();
    document.getElementById("sidebarTitle").focus();

  }


  ngAfterViewInit() {
    if (this.isIos) {
      document.getElementById("sidebarTitle").focus();

    }
    else {
      document.getElementById("sidebarTitle").focus();

    }
  }
  //show hide tooltip

  funcTooltipClicked() {
    $(".tooltip-content").css("visibility", "visible");

    this.tooltipClicked = false;
  }
  //CloseTooltip
  closeTooltip() {
    setTimeout(() => {
      $(".tooltip-content").css("visibility", "hidden");

      this.tooltipClicked = true;
    }, 200);

  }
  /**
   * Method to disable textbox and open tooltip
   */
  openTolltip() {
    this.txtboxDisable = true;

    $("#exampleModalCenter1").modal('show');
  }
  /**
   * Method To enable textbox and close tooltip
   */

  closeTolltip() {
    $('#btnttltip').focus();
    $("#exampleModalCenter1").modal('hide');
    this.txtboxDisable = false;
    this.tooltipExpandFalse();
  }




  validationamoutFr(value: any) {
    this.disableProceed = false;
    this.colorForTb = false;
    let arrVal = value;
    let frmStr = value.split(" ");
    let numberD = "";
    for (let m = 0; m < frmStr.length; m++) {
      numberD = numberD + frmStr[m];

    }
    numberD = numberD.trim().substring(0, 7);
    if (Number(numberD) > Number(999) && Number(numberD) < Number(1500001)) {
      this.disableProceed = false;
      this.colorForTb = true;
      this.isValid = false;
    }
  }

  validationamout(value: any) {
    this.disableProceed = false;
    this.colorForTb = false;
    let arrVal = value.split("$");
    let frmStr = arrVal[arrVal.length - 1];
    if (frmStr.indexOf(',') > -1) {
      let commaArr = arrVal[arrVal.length - 1].split(",")
      frmStr = commaArr.join('');
    }
    frmStr = frmStr.trim().substring(0, 7);
    if (Number(frmStr) > Number(999) && Number(frmStr) < Number(1500001)) {
      this.disableProceed = false;
      this.colorForTb = true;
      this.isValid = false;

    }

  }


  openPopup() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      let tooltpBoxVal = document.getElementById("btnttltip").getAttribute("aria-expanded");
      if (tooltpBoxVal == "false") {
        document.getElementById("btnttltip").setAttribute('aria-expanded', 'true');
      }
      else {
        document.getElementById("btnttltip").setAttribute('aria-expanded', 'false');
      }
    }
  }
  tooltipExpandFalse() {
    var isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIos) {
      document.getElementById("btnttltip").setAttribute('aria-expanded', 'false');
    }
  }

  onContinue() {
    sessionStorage.setItem("progressPercentage", String(this.nextProgressPercent));
    if (!this.incomeObj.income) {
      let temp = document.querySelector("#inputIncome") as HTMLInputElement;
      temp.focus();
      this.isValid = true;
      if (this.preQualObj.flow_type == this.switchType) {
        this.util.adobeAnalyticalErrorMsg("gross-income", "invalid-income-amount", "", null);
      }
      return;
    }
    if (!this.colorForTb) {
      let temp = document.querySelector("#inputIncome") as HTMLInputElement;
      temp.focus();
      if (this.preQualObj.flow_type == this.switchType) {
        this.util.adobeAnalyticalErrorMsg("gross-income", "invalid-income-amount", "", null);
      }
      this.isValid = true;
      return;
    }
    if (this.isValid) {
      return;
    }
    this.loader = true;
    this.disableProceed = false;
    let preQualObj = this.util.getSessionStorage();
    let arrVal = this.incomeObj.income.split("$");
    let frmStr = arrVal[arrVal.length - 1];
    if (this.currentLang == this.currLangFr) {
      let frmStr = arrVal[0].split(" ");
      let numberD = "";
      for (let m = 0; m < frmStr.length; m++) {
        numberD = numberD + frmStr[m];

      }
      frmStr = frmStr
    }
    else if (this.currentLang == this.currLangFr) {
      if (frmStr.indexOf(',') > -1) {
        let commaArr = arrVal[arrVal.length - 1].split(",")
        frmStr = commaArr.join('');
      }
    }
    preQualObj.total_gross_income = this.util.validateCurrency(frmStr.trim(), 7);
    this.util.setSessionStorage(preQualObj);


    if (this.preQualObj.flow_type == this.switchType) {
      this.router.navigate(['../cb-consent'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    } else {
      this.router.navigate([this.util.determineNextRoute(this.currentRoutePath)], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
  }

}